import { AxiosResponse } from "axios";
import { authenticationApiUrls as apiUrl } from "@/apps/merchant3/services/apiClient/apiUrl";
import { apiClient } from "@/apps/merchant3/services/apiClient/apiClient";
import ActionLogs from "@/apps/merchant3/types/ActionLogEvents";
import { store } from "@/shared-store";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import { Store } from "vuex";

export const logAction = async (
  name: string,
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  data?: Record<string, any>
): Promise<AxiosResponse<unknown>> => {
  const vuexStore = store as unknown as Store<IVuexState>;
  const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "Tablet";
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return "Mobile";
    }
    return "Desktop";
  };
  const deviceType = getDeviceType();

  const actionLogData = {
    merchantId: vuexStore.state.merchant?.merchant?.merchantId,
    clerkId: vuexStore.state.clerk?.clerk?.salesClerkId,
    cartId: vuexStore.state.carts?.cartId,
    cartTag: vuexStore.state.carts?.cartTag,
    userId: vuexStore.state.carts?.userId,
    userTag: vuexStore.state.carts?.userTag,
    adminID: vuexStore.state.merchant?.merchant?.adminId,
    productName: vuexStore.state.carts?.productVersion,
    deviceType: deviceType,
    ...data,
  };

  return await apiClient
    .post(apiUrl.ACTION_LOG, {
      name,
      category: ActionLogs.Category,
      data: actionLogData,
    })
    .then((response: AxiosResponse) => {
      return response.data;
    });
};

export default logAction;
